import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css'; // Core styles
import 'ag-grid-community/styles/ag-theme-balham.css'; // Optional theme
import './ag-theme-ela.css';
import { FetchData } from './utils/DataFetch';
import { GetCookie } from './utils/Common';

import RemoveIcon from '../images/remove-icon.png';

const moment = require('moment');

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: '1px solid #ccc', // Adds a light gray divider
  },
};

const columns = [
  {
    headerName: '',
    field: 'delete',
    width: 36,
    cellClass: 'x-grid-cell-inner',
    cellRenderer: 'removeIconRenderer',
    suppressMenu: true,
    sortable: false,
    filter: false,
  },
  {
    headerName: 'Action',
    field: 'actionCode',
    width: 100,
    cellClass: 'x-grid-cell-inner',
  },
  {
    headerName: 'Transaction Date',
    field: 'createDateTime',
    valueFormatter: (params) => moment(params.value).format('MM/DD/YYYY'),
    cellClass: 'x-grid-cell-inner',
  },
  {
    headerName: 'Check Date',
    field: 'checkDate',
    valueFormatter: (params) => moment(params.value).format('MM/DD/YYYY'),
    cellClass: 'x-grid-cell-inner',
  },
  {
    headerName: 'Check Number',
    field: 'checkNumber',
    cellClass: 'x-grid-cell-inner',
  },
  {
    headerName: 'Transfer From',
    field: 'transferFrom',
    cellClass: 'x-grid-cell-inner',
  },
  {
    headerName: 'Transfer To',
    field: 'transferTo',
    cellClass: 'x-grid-cell-inner',
  },
  {
    headerName: 'Amount',
    field: 'amount',
    width: 150,
    cellClass: 'x-grid-cell-inner',
    cellStyle: { textAlign: 'right' },
  },
];

export class PostChecksTableReceivables extends Component {
  static displayName = PostChecksTableReceivables.name;

  constructor(props) {
    super(props);
    this.user = JSON.parse(GetCookie('user'));
    this.state = {
      columnWidths: columns.reduce((acc, col) => {
        acc[col.field] = col.width || DEFAULT_MIN_WIDTH_CELL; // Initialize widths
        return acc;
      }, {}),
      isResizing: -1,
      clickCount: 0,
    };
    this.previousSelection = [];
    // Bind methods
    this.onColumnResized = this.onColumnResized.bind(this);
    this.autoSizeUnspecifiedColumns =
      this.autoSizeUnspecifiedColumns.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.onDataLoaded = this.onDataLoaded.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  componentDidMount() {
    ReactTooltip.rebuild();
  }

  componentWillUnmount() {
    clearTimeout(this.clickTimer);
  }

  autoSizeUnspecifiedColumns = () => {
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      // Check if the width is not set in the column definition
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        '.ag-header-cell-text'
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        // Ensure that you have access to the clientHeight property correctly
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });

      // Adding some padding or extra space if necessary
      maxHeight += 10; // Adjust this value based on your CSS and padding needs

      // Directly set the new header height
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  onSelectionChanged = () => {
    const currentSelection = this.gridApi.getSelectedRows();
    const currentSelectionIds = currentSelection.map((item) => item.jobId);
    const previousSelectionIds = this.previousSelection.map(
      (item) => item.jobId
    );

    console.log('Current Selection:', currentSelection);
    console.log('Previous Selection:', this.previousSelection);

    const newlySelected = currentSelection.filter(
      (node) => !previousSelectionIds.includes(node.jobId)
    );
    const newlyDeselected = this.previousSelection.filter(
      (node) => !currentSelectionIds.includes(node.jobId)
    );

    console.log('Newly Selected:', newlySelected);
    console.log('Newly Deselected:', newlyDeselected);

    // Handling changes based on newly selected or deselected
    newlySelected.forEach((node) => {
      const syntheticEvent = {
        target: {
          name: 'chk_' + node.jobNum,
          checked: true,
        },
      };
      this.props.handleCheckChange(syntheticEvent);
    });

    newlyDeselected.forEach((node) => {
      const syntheticEvent = {
        target: {
          name: 'chk_' + node.jobNum,
          checked: false,
        },
      };
      this.props.handleCheckChange(syntheticEvent);
    });

    // Update the previous selection with current
    this.previousSelection = [...currentSelection];
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.setState({ gridApiReady: true });
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns(false);
  };

  onDataLoaded = (newData) => {
    this.gridApi.setRowData(newData);
    this.autoSizeUnspecifiedColumns(true);
  };

  onColumnResized = (params) => {
    if (params.finished) {
      // Update the state with new column width
      const newWidths = { ...this.state.columnWidths };
      params.columns.forEach((column) => {
        newWidths[column.getColId()] = column.getActualWidth();
      });
      this.setState({ columnWidths: newWidths }, () => {
        // Call adjustHeaderHeight after state update to ensure it uses the latest widths
        this.adjustHeaderHeight(this.gridApi);
      });
    }
  };

  onDeleteClick = (params) => {
    if (!params || !params.data) return;
    const model = { ...params.data, EventType: 'delete' };
    FetchData('/savejobreceivable?skipInvoicedCheck=true', 'POST', this.user.token, model).then(
      (resp) => {
        if (resp === 'Success') {
          if (this.gridApi) {
            this.gridApi.applyTransaction({ remove: [params.data] });
          }
          if (this.props.handleSaveEventSuccess) {
            this.props.handleSaveEventSuccess({
              color: 'success',
              message: 'Receivable deleted successfully.',
              modal: false,
            });
          }
        } else {
          if (this.props.handleSaveEventSuccess) {
            this.props.handleSaveEventSuccess({
              color: 'danger',
              message: resp || 'Failed to delete receivable.',
              modal: false,
            });
          }
        }
      }
    );
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: [...columns],
      rowData: this.props.receivables,
      context: {
        componentParent: this,
        gridApi: this.gridApi,
        setModal: this.props.setModal,
        state: this.props.state,
      },
      animateRows: true,
      defaultColDef: defaultColDef,
      components: { removeIconRenderer: RemoveIconRenderer },
      onColumnResized: this.onColumnResized,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      onRowDoubleClicked: this.handleRowDoubleClick,
      onRowClicked: this.handleRowSingleClick,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{
          width: '100%',
          height: '300px',
        }}
      >
        <AgGridReact
          {...gridOptions}
          onGridReady={this.onGridReady}
          rowSelection={'multiple'}
        />
      </div>
    );
  }
}

// Renders the Remove icon and wires it to the delete handler
class RemoveIconRenderer extends React.Component {
  handleClick = (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    const { context, data } = this.props;
    if (context && context.componentParent) {
      context.componentParent.onDeleteClick({ data });
    }
  };

  render() {
    return (
      <img
        src={RemoveIcon}
        alt="Delete"
        style={{ width: 16, height: 16, cursor: 'pointer' }}
        onClick={this.handleClick}
      />
    );
  }
}
